import { __ } from "@wordpress/i18n";
import { ReactComponent as AddNewIcon } from "../../assets/add_new.svg";
import { ReactComponent as Cog } from "../../assets/cog.svg";
import { ReactComponent as Delete } from "../../assets/delete.svg";
import { ReactComponent as Copy } from "../../assets/copy.svg";
import { ReactComponent as AngleUp } from "../../assets/angleup.svg";
import { ReactComponent as Loader } from "../../assets/loader.svg";

import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import { SettingsContext } from "../../Settings";
import { copyToClipboard } from "../../Helpers/Utils";
import { ajaxCall } from "../../Helpers/AjaxHelper";
import { SourcesDeletePopup } from "../Sources/SourceRedirectPopup";
import { useDispatch } from "react-redux";

const Source = ({ source }) => {
  const { dispatch: settings_dispatch } = useContext(SettingsContext);

  const dispatch = useDispatch();

  const [expandInfo, setExpandInfo] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const toggleInfo = () => {
    setExpandInfo(!expandInfo);
  };

  useEffect(() => {
    const currentLocation = `${window.location.origin}${window.location.pathname}`;
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams.has("sby_access_token")) {
      urlSearchParams.delete("sby_access_token");
      urlSearchParams.delete("sby_refresh_token");
      const newQuery = urlSearchParams.toString();
      window.history.pushState(
        {},
        document.title,
        `${currentLocation}?${newQuery}`
      );
    }
  }, []);

  return (
    <div className="sb-srcs-item">
      <div className="sby-fb-srcs-item-ins">
        <div className="sb-srcs-item-avatar">
          <img src={source.profile_picture} alt={source.username} />
        </div>
        <div className="sb-srcs-item-inf">
          <div className="sb-srcs-item-name">{source.username}</div>
        </div>
        <div className="sb-srcs-item-actions">
          <div
            className="sb-srcs-item-actions-btn sb-srcs-item-delete"
            onClick={() => {
              setShowDeletePopup(!showDeletePopup);
            }}
          >
            <Delete />
          </div>
          {expandInfo && (
            <div
              className="sb-srcs-item-actions-btn sb-srcs-item-angle-up"
              onClick={toggleInfo}
            >
              <AngleUp />
            </div>
          )}
          {!expandInfo && (
            <div
              className="sb-srcs-item-actions-btn sb-srcs-item-cog"
              onClick={toggleInfo}
            >
              <Cog />
            </div>
          )}
        </div>
      </div>
      {expandInfo && (
        <div className="sby-fb-srcs-info sby-fb-fs">
          <div className="sby-fb-srcs-info-item">
            <strong>{__("ID", "feeds-for-youtube")}</strong>
            <span>{source.channel_id}</span>
            <div
              className="sby-fb-srcs-info-icon"
              onClick={() => {
                copyToClipboard(source.channel_id);
                dispatch({
                  type: "add_notification",
                  payload: {
                    type: "success",
                    content: __("Copied to Clipboard", "feeds-for-youtube"),
                  },
                });
              }}
            >
              <Copy />
            </div>
          </div>
        </div>
      )}
      {showDeletePopup && (
        <SourcesDeletePopup
          username={source.username}
          callback={() => {
            ajaxCall("remove_connected_account", {
              account_id: source.channel_id,
            }).then(() => {
              settings_dispatch({
                type: "delete_source",
                payload: source.channel_id,
              });
            });
          }}
          hideCallback={() => {
            setShowDeletePopup(!showDeletePopup);
          }}
        />
      )}
    </div>
  );
};

const APIField = () => {
  const { register, settings } = useContext(SettingsContext);
  const { status } = settings.api_check_response || {};

  const { onChange, onBlur, name, ref } = register("api_key");

  const [isValid, setIsValid] = useState(status ?? null);
  const [isLoading, setIsLoading] = useState(false);

  const [currentValue, setCurrentValue] = useState(settings.api_key);

  return (
    <div
      className={`sb-license-box ${isValid ? "license-valid" : ""} ${
        isValid === false ? "license-invalid" : ""
      }`}
    >
      <div className="d-flex">
        <div className="field-left-content">
          <div className="sb-form-field">
            <input
              type="text"
              {...register("api_key")}
              className="sby-form-field"
              defaultValue={settings.api_key}
              ref={ref}
              name={name}
              onChange={(evt) => {
                setCurrentValue(evt.target.value);
                onChange(evt);
              }}
              onBlur={onBlur}
              placeholder={__("Enter API Key", "feeds-for-youtube")}
            />
            {isValid === true && (
              <span className="field-icon fa fa-check-circle" />
            )}
            {isValid === false && (
              <span className="field-icon field-icon-error fa fa-times-circle" />
            )}
          </div>
          {isValid === false && (
            <div>
              <span className="sby-error-text">
                {parse(
                  __(
                    "Entered API Key is invalid. You can double check the API Key or learn more about generating them <a target='_blank' href='https://smashballoon.com/youtube-api-key/'>here</a>",
                    "feeds-for-youtube"
                  )
                )}
              </span>
            </div>
          )}
        </div>
        <div className="field-right-content">
          <button
            type="button"
            className="sby-btn sb-btn-grey loading"
            onClick={() => {
              setIsLoading(true);
              ajaxCall("verify_api_key", {
                api_key: currentValue,
              })
                .then((res) => res.json())
                .then(({ data }) => {
                  const { status } = data;
                  setIsValid(status === true);
                })
                .finally(() => {
                  setIsLoading(false);
                });
            }}
          >
            {isLoading && <Loader />}
            {settings.api_key !== "" &&
              settings.api_key &&
              __("Update", "feeds-for-youtube")}
            {(settings.api_key === "" || !settings.api_key) &&
              __("Add", "feeds-for-youtube")}
          </button>
        </div>
      </div>
    </div>
  );
};

const SourcesSection = () => {
  const { state, setShowSourcesPopup } = useContext(SettingsContext);
  const { sources } = state;
  const connectAccount = () => {
    setShowSourcesPopup(true);
    setTimeout(() => {
      window.location.href = window.sby_settings.connectionURL;
    }, 5000);
  };
  return (
    <>
      <div className="sb-tab-box sb-reset-box-style sb-manage-sources-box clearfix">
        <div className="tab-label">
          <h3>{__("Connected YouTube Account", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <span className="help-text">
              {__(
                "This account is used to display channel feeds. It will not affect playlist, favorites, search, livestreams or single videos stream.",
                "feeds-for-youtube"
              )}
            </span>
            <div className="sb-sources-list mb-2">
              {Object.entries(sources).length === 0 && (
                <div
                  className="sb-srcs-item sb-srcs-new"
                  onClick={connectAccount}
                >
                  <span className="add-new-icon">
                    <AddNewIcon />
                  </span>
                  <span>{__("Add Source", "feeds-for-youtube")}</span>
                </div>
              )}
              {Object.entries(sources).map((account, index) => {
                return <Source key={index} source={account[1]} />;
              })}
            </div>
            {Object.entries(sources).length > 0 && (
              <span>
                {parse(__("Feed not working? ", "feeds-for-youtube"))}
                <a
                  className="sb-bold sb-cursor-pointer"
                  onClick={connectAccount}
                >
                  {__(
                    "Try Re-authenticating connected account",
                    "feeds-for-youtube"
                  )}
                </a>
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="sb-tab-box clearfix">
        <div className="tab-label">
          <h3>{__("API Key", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field d-flex">
          <div className="sb-form-field">
            <span className="help-text">
              {parse(
                __(
                  "API Key is used to fetch from the YouTube API, and is required for several features to work. <a target='_blank' href='https://smashballoon.com/youtube-api-key/'>Learn more</a>",
                  "feeds-for-youtube"
                )
              )}
            </span>
            <div className="sby-tab-field-inner-wrap pt-1">
              <APIField />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SourcesSection;
